import { Button } from "@nextui-org/react";
import { Col, Row } from "antd";
import React from "react";
import { LuPhoneForwarded } from "react-icons/lu";
import { useNotification } from "./CustomStatus/UseNotification";

const Helpline = () => {
  const { openToast } = useNotification();
  const copyToClipboard = (text) => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).catch((err) => {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
      });
    } else {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
    }
  };
  return (
    <Row justify="center">
      <Col className="py-7 text-center">
        <div className="my-3 text-[#425462] font-light">
          Questions? Call Customer Support.
        </div>
        <Button
          onClick={() => {
            // navigator.clipboard.writeText("+91 73864 47002");
            window.location.href = "tel:9240218436";
            copyToClipboard("9240218436");

            openToast({
              content: <p className="text-[#0E8743]">Phone number copied</p>,
              type: "success",
            });
          }}
          className="bg-[#F0F3FE] text-[#192438] font-medium"
          startContent={
            <div className="bg-[#4862EE] p-2 rounded-full">
              <LuPhoneForwarded className="text-white text-lg" />
            </div>
          }
        >
          +91 92402 18436
        </Button>
      </Col>
    </Row>
  );
};

export default Helpline;
